import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { STATIC_ROOT } from '../../constants';

import SvgComponent from '../SvgComponent';

import './ErrorMessageComponent.scss';

const ErrorMessageComponent = ({ message, onClose, visible, className, i18n }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (visible && containerRef.current) {
            containerRef.current.focus();
        }
    }, [visible]);

    if (!visible) return null;

    return (
        <div
            ref={containerRef}
            tabIndex="-1"
            role="alert"
            aria-live="assertive"
            className={`form-error-message ${className || ''}`}>
            <div className="picto">
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-errors.svg`}
                    width={20}
                    height={20}
                    aria-hidden="true"
                    focusable="false"
                />
            </div>
            <div>{message}</div>
        </div>
    );
};

ErrorMessageComponent.propTypes = {
    message: PropTypes.node.isRequired,
    visible: PropTypes.bool,
    className: PropTypes.string
};

ErrorMessageComponent.defaultProps = {
    visible: true
};

export default ErrorMessageComponent;



// WEBPACK FOOTER //
// ./src/components/form-message/ErrorMessageComponent.js